import { render, staticRenderFns } from "./QualificationSection.vue?vue&type=template&id=9345620a&scoped=true&"
import script from "./QualificationSection.vue?vue&type=script&lang=js&"
export * from "./QualificationSection.vue?vue&type=script&lang=js&"
import style0 from "./QualificationSection.vue?vue&type=style&index=0&id=9345620a&prod&lang=css&"
import style1 from "./QualificationSection.vue?vue&type=style&index=1&id=9345620a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9345620a",
  null
  
)

export default component.exports